import { SANTA_MEMBERS_APP_ID } from '../constants/applications';
import { getApplicationConfig } from '../../common/selectors/communities-context-selectors';

export const isMemberAreaActive = state => {
  return getApplicationConfig(state, SANTA_MEMBERS_APP_ID).isInstalled;
};
